<template>
  <section class="content-blog">
    <div class="content-blog-itens">
      <HeaderTitle :title="'Blog'" :image="'blog'" />
      <div class="content-blog-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterPosts' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
        </div>
        <div
          class="row content-blog-itens-body--category"
          v-for="category in categoriesWithPosts"
          :key="category.id_category"
        >
          <div
            class="w-100 d-flex items-center justify-content-between col-12 mb-4"
          >
            <h2 class="title--category">{{ category.category_name }}</h2>
            <button
              class="btn-view-all"
              @click="
                $router.push({
                  name: 'ListPostsByCategory',
                  params: { idCategory: category.id_category },
                })
              "
            >
              Ver todos
            </button>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-4 col-xl-3"
            v-for="post in category.posts"
            :key="post.id_post"
          >
            <CardPost :post="post" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeaderTitle from "@/components/headers/HeaderTitle";
import CardPost from "@/views/Blog/components/CardPost";

export default {
  data() {
    return {
      objPost: {
        title: "Desenvolvimento",
        text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
        image: "image-post.png",
      },
    };
  },
  components: {
    HeaderTitle,
    CardPost,
  },
  computed: {
    ...mapGetters({ categoriesWithPosts: "Blog/categoriesWithPosts" }),
  },
  methods: {
    ...mapActions("Blog", ["consultCategoriesWithPosts"]),
  },
  mounted() {
    this.consultCategoriesWithPosts();
  },
};
</script>

<style lang="scss">
.content-blog-itens-body--category {
  padding: 30px 0px;
  .title--category {
    font-size: 24px;
    font-family: "Font Bold";
    color: var(--black);
    text-align: left;
  }
  .btn-view-all {
    background: 0;
    border: 0;
    font-size: 24px;
    font-family: "Font Bold";
    color: var(--blue);
    text-transform: uppercase;
    margin-bottom: 0;
    @media (max-width: 991px) {
      font-size: 18px;
    }
  }
}
</style>
